export default __webpack_public_path__ + "533081e4b5ea3d0989f14efbabfa4b7e.svg";